import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import TruckKanbanService from '../../../services/TruckKanbanService';
import { translate, getUserNameToName, formatData } from '../../../utils/util';
import { Input, BackButton, Title, Button, ListPagination } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import * as actionsTruckKanban from '../../../actions/truckKanbanAction';

const List = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            partnumbercode: '',
        });
    const [partnumbers, setPartnumbers] = useState([]);
    const [instanceM, setInstanceM] = useState();
    const [selectedPartnumbers, setSelectedPartnumbers] = useState([]);
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        getPartnumber()

        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getPartnumber();

        // eslint-disable-next-line
    }, [currentPage, refresh]);


    useEffect(() => {
        if (props.partnumbers?.items?.length > 0) {
            if (partnumbers.length > 0 && currentPage === 0) {
                setPartnumbers([...props.partnumbers.items]);
            } else {
                setPartnumbers((prevState) => ([...prevState, ...props.partnumbers.items]));
            }
        } else {
            setPartnumbers([]);
        }
        // eslint-disable-next-line
    }, [props?.partnumbers?.items]);

    const getPartnumber = () => {
        if (validateInputsRequired("formfilter")) {
            Object.assign(filter, {
                PageSize: 20,
                PageIndex: currentPage
            });
            props.getHighCostMaterialPaged(filter, () => {
                if (instanceM) {
                    instanceM[1].close();
                }
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSelectItem = (item) => {
        props.select(item)
        props.history.push({
            pathname: './insert',
            state: { update: true }
        })
    }

    const onDelete = () => {
        props.deleteHighCostMaterial(props.partnumber?.id, () => {
            setSelectedPartnumbers([])
            setCurrentPage(0)
            setRefresh(refresh + 1)
        })
    }

    const onClickDelete = (item) => {
        props.select(item)
        const modal = M.Modal.init(document.getElementById('confirmDelete'));
        modal.open();
    }

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedPartnumbers);
        let index = selectedPartnumbers.findIndex((e) => e === item.id);
        if (index === -1) {
            arr.push(item.id)
        } else {
            arr.splice(index, 1);
        }
        setSelectedPartnumbers(arr)
    }

    const deleteSelectedItems = () => {
        props.deleteSelected(selectedPartnumbers, () => {
            setSelectedPartnumbers([])
            setCurrentPage(0)
            setRefresh(refresh + 1)
        })
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('truck-kanban:list-high-cost-material')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '25px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('filter', 'physical-confirmation')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <form id="formfilter" className="col s12">
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="partnumbercode"
                                            name='partnumbercode'
                                            placeholder={translate('partnumber', 'stock')}
                                            type="text"
                                            defaultValue={filter?.partnumbercode || ''}
                                            onChange={onChange}
                                            maxLength="10"
                                        />
                                    </div>
                                </form>
                            </div>
                        </li>
                    </ul>
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text={translate('search', 'general')} onClick={() => getPartnumber()} />
                    </div>
                    {selectedPartnumbers.length > 0 &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true" text="Excluir Selecionados" onClick={() => deleteSelectedItems()} />
                        </div>
                    }
                </div>
                <div id="listtransmissions">
                    <ListPagination
                        page={props.partnumbers?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={partnumbers.map((item, index) =>
                            <div
                                key={index}
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 10px' }}
                            >
                                <div onClick={() => onSelectItem(item)}>
                                    <span className="title sixth-text-color" style={{ display: 'block' }}>{item.partNumberCode}</span>
                                    <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>{formatData(item?.updatedOn)}</span>
                                    <span className="sixth-text-color" style={{ marginLeft: '10px' }}>{getUserNameToName(props?.usersFromElog, item?.updatedBy)}</span>
                                </div>
                                <span className="title sixth-text-color">
                                    <i style={{ cursor: 'pointer' }} onClick={() => onClickDelete(item)} className="mdi mdi-delete"></i>
                                    <Input
                                        type="checkbox"
                                        onChange={() => onCheckItem(item)}
                                        id="select"
                                        name="select"
                                    />
                                </span>
                            </div>
                        )}
                    />
                </div>
            </div>
            <ConfirmModal
                id="confirmDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onDelete}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        partnumbers: state.truckKanbanReducer.highCostMaterials,
        user: state.userReducer.user,
        usersFromElog: state.usersElogReducer.usersElog,
        partnumber: state.truckKanbanReducer.highCostMaterial,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getHighCostMaterialPaged: (filter, callback) => {
            dispatch(TruckKanbanService.getHighCostMaterialPaged(filter, callback));
        },
        deleteHighCostMaterial: (partnumberId, callback) => {
            dispatch(TruckKanbanService.deleteHighCostMaterial(partnumberId, callback));
        },
        select: (select) => {
            dispatch(actionsTruckKanban.setHighCostMaterial(select));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(TruckKanbanService.deleteSelected(selectedIds, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(List)));
